export const errorMessages: {
    [statusCode: number]: {
      [errorKey: string]: string;
    } | string;
   } = {
    201: "Saved Successfully",
    401: "You session has timed out. Please signin again to continue.",
    403: "You do not have permission to perform this action. Please contact your administrator.",
    408: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
    422: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
    500: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
    502: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
    503: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
    409:{
      AlreadyActiveCallSession : "Session already active",
      UserAlreadyExist : "User already exists ",
      ContactNumberAlreadyExist : "Contact number already exists",
      ORG_ACTIVE_USER_LIMIT_EXCEEDED :"The organization has exceeded the maximum number of active users (48). Please reduce active users before creating new tickets."
    },
    404: {
      RecordNotFound:{
        "/api/tickets":"No Ticket Found",
        "/api/user/:id/csl": "No Users Found"
      }
    },  
    400: {
      InvalidTicketSubject: "Invalid ticket subject.",
      InvalidHospitalId: "Invalid Organization. Please select correct organization.",
      InvalidTicketId: "No Tickets Found",
      InvalidPrivateMessageReq: "You can not send the Internal message.",
      MaxFileError: "You can only upload a maximum of 5 files.",
      MaxFileSizeError: "The file you are trying to upload exceeds the maximum allowed size.",
      FileNull: "The file format is not supported. Please upload a valid file type",
      InvalidFileType: "The file format is not supported. Please upload a valid file type",
      InvalidCustomStatusId: "Select the correct ticket status.",
      InvalidZendeskOrgId: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
      InvalidRegion: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
      InvalidUsers: "Please select the correct users.",
      UserObjectNull: "Please fill all the required field.",
      UserAlreadyExist: "User email already exist. ",
      ContactNumberAlreadyExist: "Contact number already exists",
      InvalidOrgInZendesk: "Oops! Something went wrong. We’re unable to process your request right now. Please try again later",
      InvalidUser: "User does not exists",
      InvalidTokenRequest: "Notification token can not be empty.",
      InvalidTicketIdOrTopic: "Invalid Input",
      AlreadyActiveCallSession:"Your session is currently active for ticket Id",
      InvalidTopic:"There was an issue identifying your session. Please try leaving the call again. If the problem continues, contact support."
    },
   };